import React from "react";
import i18n from "i18n";
import SafteryCritical from "assets/icons/safety-critical.svg";
import HasImages from "assets/icons/images.svg";
import { ChipTypeEnums } from "constants/enums";

export const DefectTableHeader = (customCaptions) => {
	return [
		{
			id: 1,
			name: i18n.t("label.entityNumber", { entity: customCaptions?.defect }),
			width: "20px",
		},
		{
			id: 2,
			name: (
				<div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
					<img src={SafteryCritical} alt="safety critical" />
					<img src={HasImages} alt="has images" style={{ width: 20, height: 20 }} />
				</div>
			),
			width: "50px",
			disableSort: true,
		},
		{ id: 3, name: customCaptions?.model, minWidth: "230px" },
		{ id: 4, name: `${customCaptions?.asset}`, width: "40px" },
		{ id: 5, name: customCaptions?.defectStatus },
		{ id: 6, name: customCaptions?.interval, width: "30px" },
		{ id: 7, name: customCaptions?.stage, minWidth: "250px" },
		{ id: 8, name: customCaptions?.zone, minWidth: "250px" },
		{ id: 9, name: customCaptions?.task, minWidth: "250px" },
		{
			id: 10,
			name: i18n.t("label.entityDetails", { entity: customCaptions?.defect }),
			width: "500px",
			minWidth: "500px",
		},
		{ id: 11, name: customCaptions?.riskRating, width: "30px" },
		{ id: 17, name: customCaptions?.system, width: "30px" },

		{ id: 12, name: customCaptions?.defectType, width: "152px" },
		{ id: 13, name: i18n.t("label.createdBy"), minWidth: "170px" },
		{ id: 14, name: i18n.t("label.createdDate"), minWidth: "170px" },
		{ id: 15, name: customCaptions?.serviceWorkOrder, minWidth: "60px" },
		{ id: 16, name: i18n.t("entity.notificationNumber"), width: "60px" },
	];
};
export const DefectTableColumns = () => {
	return [
		"number",
		"safetyCritical",
		"modelName",
		"siteAssetName",
		"defectStatusName",
		"intervalName",
		"stageName",
		"zoneName",
		"taskName",
		"details",
		"riskRatingName",
		"system",
		"defectTypeName",
		"createdUserName",
		"createdDateTime",
		"serviceWorkOrder",
		"workOrder",
	];
};

// Chip type ids are sourced from ChipTypeEnums (constants/enums.js) so the
// numeric contract has one owner; a chip type added there without a caption
// entry here just falls back to no caption, rather than the two silently
// drifting apart.
export const ChipTypesConstants = (customCaptions) => [
	{ id: ChipTypeEnums.Undefined, type: "Undefined", caption: "Contains" },
	{
		id: ChipTypeEnums.DefectStatusType,
		type: "DefectStatusType",
		caption: "Defect Status Type",
	},
	{
		id: ChipTypeEnums.DefectStatusID,
		type: "DefectStatusID",
		caption: "Defect Status",
	},
	{
		id: ChipTypeEnums.SiteDepartmentID,
		type: "SiteDepartmentID",
		caption: "Department",
	},
	{
		id: ChipTypeEnums.DefectRiskRatingID,
		type: "DefectRiskRatingID",
		caption: `${customCaptions?.riskRating ?? "Defect Risk Rating"}`,
	},
	{
		id: ChipTypeEnums.ModelID,
		type: "ModelID",
		caption: `${customCaptions?.model ?? "Model"}`,
	},
	{
		id: ChipTypeEnums.DefectSystemID,
		type: "DefectSystemID",
		caption: `${customCaptions?.system ?? "System"}`,
	},
	{
		id: ChipTypeEnums.DefectTypeID,
		type: "DefectTypeID",
		caption: ` ${customCaptions?.defectType ?? "Defect Type"}`,
	},
	{
		id: ChipTypeEnums.NotificationRaised,
		type: "NotificationRaised",
		caption: "NotificationRaised",
	},
	{
		id: ChipTypeEnums.SiteAssetID,
		type: "SiteAssetID",
		caption: `${customCaptions?.asset ?? "Asset"}`,
	},
	{
		id: ChipTypeEnums.DefectWorkOrder,
		type: "DefectWorkOrder",
		caption: `${customCaptions?.defectWorkOrder ?? "Defect Work Order"}`,
	},
	{
		id: ChipTypeEnums.ServiceWorkOrder,
		type: "ServiceWorkOrder",
		caption: `${customCaptions?.serviceWorkOrder ?? "Service Work Order"}`,
	},
	{
		id: ChipTypeEnums.ModelTypeID,
		type: "ModelTypeID",
		caption: `${customCaptions?.modelType ?? "Model Type"} `,
	},
	{
		id: ChipTypeEnums.UserID,
		type: "UserID",
		caption: `${customCaptions?.user ?? "User"}`,
	},
	{
		id: ChipTypeEnums.Interval,
		type: "IntervalID",
		caption: `${customCaptions?.interval ?? "Interval"}`,
	},
	{
		id: ChipTypeEnums.Role,
		type: "RoleID",
		caption: `${customCaptions?.role ?? "Role"}`,
	},
	{
		id: ChipTypeEnums.Zone,
		type: "ZoneID",
		caption: `${customCaptions?.zone ?? "Zone"}`,
	},
	{
		id: ChipTypeEnums.Stage,
		type: "StageID",
		caption: `${customCaptions?.stage ?? "Stage"}`,
	},
	{
		id: ChipTypeEnums.Arrangement,
		type: "ArrangementID",
		caption: `${customCaptions?.arrangement ?? "Arrangement"}`,
	},
];
